import { render, staticRenderFns } from "./change-company.vue?vue&type=template&id=ec052a3a&scoped=true"
import script from "./change-company.vue?vue&type=script&lang=js"
export * from "./change-company.vue?vue&type=script&lang=js"
import style0 from "./change-company.vue?vue&type=style&index=0&id=ec052a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec052a3a",
  null
  
)

export default component.exports